import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { EmploymentProps } from '../../../models/arc-epi-props';
import { Employment } from '../../employment/employment-model';

interface Props {
	employmentData: Employment;
	employerLabel: string;
	hireDateLabel: string;
	clientNumberLabel: string;
}
export function EmploymentView(props: Props) {
	const { employmentData, employerLabel, hireDateLabel, clientNumberLabel } = props;
	const stip = useSelector<TcsmStates, Employment>(state => state?.employmentState?.currentEmployment);
	const nonStip = useSelector<TcsmStates, Employment>(state => state?.employmentState?.nonStipendiaryEmployment);
	const settings = useSelector<TcsmStates, EmploymentProps>(state => state?.epiProps?.employmentSettingsState?.epiContent);

	const EmployerView = () => {
		return (
			<>
				<p>{employmentData?.employer_name}</p>
				<p>{employmentData?.employer_location}</p>
				<p>{`${clientNumberLabel || 'Client Number'}: ${employmentData?.employer_client_number}`}</p>
			</>

		);
	};

	if (isEmpty(employmentData)) {
		return (
			<p>no current employment</p>
		);
	}

	return (
		<>
			<LabelAndValue label={employerLabel} value={<EmployerView />} />
			{stip && <LabelAndValue label={hireDateLabel} value={getFormattedDate(stip?.hire_date)} />}
			{nonStip && <LabelAndValue label={settings?.nonStipStartDateLabel} value={getFormattedDate(nonStip?.hire_date)} />}
		</>
	);
}